import Container from "components/general/Container";
import ScrollContainer from "components/general/ScrollContainer";
import { AdminNavigation } from "components/navigation";
import { Box } from "components/ui";
import { Slot, usePathname } from "expo-router";
import React from "react";
import { useWindowDimensions } from "react-native";
import { useIsMobile } from "utils/hooks/useIsMobile";
export default function MainLayout() {
	const { height: windowHeight } = useWindowDimensions();
	const currentPath = usePathname();
	const isMobile = useIsMobile();
	const [isAdminMenuOpen, setIsAdminMenuOpen] = React.useState(false);
	if (isMobile) {
		return (
			<Box position="relative" zIndex={2} gap={24} flex={1}>
				{currentPath === "/admin" ? null : <AdminNavigation />}
				<Slot />
			</Box>
		);
	}
	return (
		<ScrollContainer>
			<Container sx={{ justifyContent: "center", height: "$full" }}>
				<Box width={"$full"} height={"$full"}>
					<Box height={"$full"} flexDirection={isMobile ? "column" : "row"} justifyContent="center" bg="$neutral25" borderRadius={isMobile ? 0 : 16} overflow="hidden" marginVertical={isMobile ? 0 : 16}>
						{currentPath === "/admin" ? null : <AdminNavigation />}
						<Box paddingHorizontal={28} flex={1}>
							<Slot />
						</Box>
					</Box>
				</Box>
			</Container>
		</ScrollContainer>
	);
}
